import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import {
    FlowOfFunds,
    SaveConsiderationCommentRequest,
} from '../../../../models/FlowOfFunds/flow-of-funds.model';

export interface SaveConsiderationCommentParams extends SaveConsiderationCommentRequest {
    engagementId: number;
    section: number;
    rowKey: number;
}

export interface SaveConsiderationCommentRejection {
    isConflict: boolean;
}

export const SaveConsiderationComment = createAsyncThunk(
    'flowOfFunds/saveConsiderationComment',
    async (params: SaveConsiderationCommentParams, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.put(
                `/api/PurchasePriceConsideration/${params.engagementId}/Rows/${params.section}/${params.rowKey}/Comment`,
                {
                    comment: params.comment,
                }
            );

            if (response.status !== 200) {
                throw new Error('Failed to save the comment');
            }

            return response.data as FlowOfFunds;
        } catch (error) {
            createNotification('Could not save the comment.', 'error');
            return dispatch.rejectWithValue({
                isConflict: false,
            } as SaveConsiderationCommentRejection);
        }
    }
);
